import { render, staticRenderFns } from "./orgMember.vue?vue&type=template&id=1ef5ebde&scoped=true&"
import script from "./orgMember.vue?vue&type=script&lang=js&"
export * from "./orgMember.vue?vue&type=script&lang=js&"
import style0 from "./orgMember.vue?vue&type=style&index=0&id=1ef5ebde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5ebde",
  null
  
)

export default component.exports